import { formatStartEndDateString } from "common/utils/dateAndTimeUtils";

const SalesChartTitle = ({
  partnerName,
  productTypeName,
  startYear = "",
  endYear = "",
}) => {
  startYear = startYear || "All Years";

  return (
    <span className="Font_H7 Font_Title_Color">
      {partnerName} | {productTypeName} {startYear && "|"}{" "}
      {formatStartEndDateString(startYear, endYear)}
    </span>
  );
};

export default SalesChartTitle;
